import {scrollTo} from "@/functions/scrollTo";

export default {
	methods: {
		scrollTo(target, options = {}) {
			scrollTo(target, options);
		},
		resetScroll(options = {}) {
			this.scrollTo(0, options);
		},
	},
};
